<template>
  <i class="fa fa-images" :class="{ 'brand-red': communicationhasDocuments }"
    v-show="communicationIsChecked"
    @click="$emit('openModal')"
  />
</template>

<script>
  export default {
    props: ['communication', 'checkedType', 'documentsType'],
    data() {
      return {
      }
    },
    computed: {
      communicationIsChecked() {
        return this.$store.getters[this.checkedType](this.communication)
      },
      communicationhasDocuments() {
        return this.$store.getters[this.documentsType](this.communication)
      },
    }
  }
</script>
<style scoped>
  .fa {
    margin-left: 5px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/trials/DocumentsIcon.vue